// Helpers de formatação numérica/monetária.
// O backend do módulo de produtos retorna decimais como string ("21.85", "100.000")
// por causa do cast do Eloquent — sempre normalize antes de calcular/formatar.

const LOCALE_BY_CURRENCY = {
  USD: "en-US",
  BRL: "pt-BR",
  PYG: "es-PY",
};

// Converte "21.85" / 21.85 / null em Number (ou null quando vazio/inválido).
function parseDecimal(value) {
  if (value === null || value === undefined || value === "") return null;
  const parsed = typeof value === "number" ? value : parseFloat(value);
  return Number.isNaN(parsed) ? null : parsed;
}

// Formata um valor monetário conforme a moeda do produto (currency vem por produto).
// Sem conversão entre moedas nesta versão — apenas exibição do símbolo/código.
function formatCurrency(value, currency) {
  const parsed = parseDecimal(value);
  if (parsed === null) return "";
  const code = currency || "BRL";
  const locale = LOCALE_BY_CURRENCY[code] || "pt-BR";
  try {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
    }).format(parsed);
  } catch (error) {
    // Moeda desconhecida pelo Intl: cai para número + código.
    return `${code} ${parsed.toFixed(2)}`;
  }
}

// Formata quantidade de estoque (3 casas, como o backend).
function formatQuantity(value) {
  const parsed = parseDecimal(value);
  if (parsed === null) return "";
  return parsed.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });
}

export { parseDecimal, formatCurrency, formatQuantity };
